export default {"src":"/_next/static/media/declined.c3b1942d.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};